module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-zoom-in-8c5f5423ad8720ffd9d1d19b65621f21.png";